import template from './mailChimpAutoSync.template.html';

export default {
  bindings: {
    onFinish: '&'
  },
controller: class controller {
    constructor($mdDialog, mailChimpService, uiService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = () => {
        $mdDialog
          .show({
            locals: {},
            template,
            controllerAs: '$ctrl',
            controller() {
              const self = this;
              self.lists = [];
              self.idList = '';
              self.listName = '';
              self.isReady = false;

              mailChimpService.lists().then((lists) => {
                self.lists = lists;
                self.isReady = true;
              });

              self.confirm = () => {
                self.isReady = false;
                if (self.idList !== '') {
                  self.listName = _.find(self.lists, (list) => {
                    return list.id === self.idList;
                  }).name;
                  $mdDialog.hide({ id: self.idList, name: self.listName });
                } else {
                  uiService.toast({
                    text: {
                      p1: 'Creating',
                      p2: self.listName,
                      p3: 'MailChimp list'
                    },
                    progress: true
                  });
                  mailChimpService.listCreate({ name: self.listName }).then((result) => {
                    if (result && result.status) {
                      $mdDialog.hide({ id: result.id, name: result.name });
                    } else {
                      $mdDialog.hide();
                    }
                  });
                }
              };
              self.cancel = () => {
                $mdDialog.hide(false);
              };
            },
            clickOutsideToClose: false
          })
          .then((res) => {
            ctrl.onFinish({ status: res });
          });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
